import NoDataMessage from '../typography/NoDataMessage';
import React, { ReactNode } from 'react';

const DataCheck: React.FC<DataCheckProps> = ({
    children,
    dataExists,
    isFetching,
    error,
    errorMessage = 'There was an error retrieving the data.',
    noDataMessage = 'There is no data to display.',
}) => {
    if (error) return <NoDataMessage>{errorMessage}</NoDataMessage>;
    if (isFetching && !dataExists)
        return (
            <NoDataMessage>
                <i className="far fa-spinner-third fa-spin"></i>
            </NoDataMessage>
        );
    if (!dataExists) return <NoDataMessage>{noDataMessage}</NoDataMessage>;
    return <>{children}</>;
};

interface DataCheckProps {
    children: ReactNode;
    dataExists: boolean;
    isFetching: boolean;
    error: string | null;
    errorMessage?: string;
    noDataMessage?: string;
}

export default DataCheck;
